<template>
  <div class="clear-layout">
    <main class="content">
      <slot />
    </main>

    <notifications position="top right" />
  </div>
</template>

<script>
export default {
  name: 'ClearLayout'
}
</script>

<style lang="scss" scoped>
.content {
  min-height: 100vh;
}
</style>
